import React from "react";
import { Col, Row } from "antd";
import { LoadingSpinner, Card, AccordionV2, EmptyStateV2 } from "pepsico-ds";
import SingleSelectDropdown from "../../../components/Dropdown/SingleSelectDropdown";
import ResinLineChart from "../../../components/Charts/ResinChart/ResinLineChart";
import DropdownWithIcons from "../../../components/Modal/DropdownWithIcons";
import { SkeletonList } from "../../../components/Skeleton/ResinSkeleton";
import CmaTable from "../../../components/Table/CmaTable";
import NoData from "../../../components/NoData/NoData";
import reset_icon from "../../../assets/reset_icon.svg";
import { useCmaSource } from "./CmaSourceContext";

// CMA source component. CMA state, redux selectors, handler functions and
// effects live in CmaSourceContext.js (shared via CmaSourceProvider) so
// that CMA logic is fully self-contained; this component only renders the
// "filters" or "content" slice of the CMA UI depending on `section`.j
const CmaSource = props => {
  const { section } = props;
  const {
    selectedTab,

    // Pricing tab filter props
    geographyList, geographySelected, onGeographyChange,
    productList, productSelected, onProductChange,
    gradeList, gradeSelected, onGradeChange,
    conceptList, conceptSelected, onConceptChange,
    termsList, termsSelected, onTermsChange,
    cmaPricingFromDates, cmaPricingFromDatesSelected, onPETResinFromDateChange,
    cmaPricingToDates, cmaPricingToDatesSelected, onPETResinToDateChange,
    unitList, unitsSelected, onUnitsChange,
    resetButtonHandler,
    renderPricingFilterDropdown,

    // Reports tab filter props
    cmaReportFromDates, cmaReportFromDateSelected, onCmaReportFromDateChange,
    cmaReportToDates, cmaReportToDateSelected, onCmaReportToDateChange,

    // Reports tab content props
    isCMADataLoading,
    renderedCmaSections, cmaAccordionSelectedIndex, cmaPdfReportData,
    renderSection,
    pdfUrl,

    // Pricing tab content props
    isUserDataLoading, isFilterDataLoading, isLineDataLoading,
    linechartRef,
    checkPDFDownloaded,
    renderForecastLegend,
    activePricingLineChartData,
    resinChartData,
    resinLineChartActualData,
    resinForecastStartVal,
    resinSeriesLineChartIndex,
    resinFirstForecastYearMonth,
    resinFirstForecastKeysToBeMergedActualLast,
    currencySymbol,
    cmaTableRef,
    isTableDataLoading,
    activePricingTableData,
    cmaColumns
  } = useCmaSource();

  return (
    <>
      {/* Pricing Tab Dropdown Options in CMA */}
      {section === "filters" && selectedTab === 1 && (
        <div
          style={{
            width: "100%"
          }}
        >
          <>
            <Row
              gutter={[10, 0]}
              justify="start"
              wrap={false}
              style={{
                width: "100%",
                marginTop: "12px",
                alignItems: "flex-end",
                flexWrap: "nowrap"
              }}
            >
              {/* {renderPricingFilterDropdown("Geography", geographyList, geographySelected, onGeographyChange, { flex: "1" })} */}
              {renderPricingFilterDropdown("Product", productList, productSelected, onProductChange, { flex: "1" })}
              {renderPricingFilterDropdown("Geography", geographyList, geographySelected, onGeographyChange, { flex: "1" })}
              {renderPricingFilterDropdown("Grade", gradeList, gradeSelected, onGradeChange, { flex: "1" })}
              {renderPricingFilterDropdown("Concept", conceptList, conceptSelected, onConceptChange, { flex: "1" })}
              {renderPricingFilterDropdown("Terms", termsList, termsSelected, onTermsChange, { flex: "1" })}
              <Col flex="1">
                <SingleSelectDropdown
                  className="buy-con-dropdown-modal cma-dropdown"
                  label="Unit of Measure"
                  childList={unitList}
                  selectedValue={unitsSelected}
                  setSelectedValue={onUnitsChange}
                />
              </Col>
              <Col flex="1">
                <SingleSelectDropdown
                  className="buy-con-dropdown-modal cma-dropdown"
                  label="From Date"
                  childList={cmaPricingFromDates}
                  selectedValue={cmaPricingFromDatesSelected}
                  setSelectedValue={onPETResinFromDateChange}
                />
              </Col>
              <Col flex="1">
                <SingleSelectDropdown
                  className="buy-con-dropdown-modal cma-dropdown"
                  label="To Date"
                  childList={cmaPricingToDates}
                  selectedValue={cmaPricingToDatesSelected}
                  setSelectedValue={onPETResinToDateChange}
                />
              </Col>
              
            </Row>
            <Row justify="end">
              <button className="reset-button" onClick={resetButtonHandler} style={{ marginTop: '12px', marginRight:'0.8rem' }}>
                <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                <span>Reset Filters</span>
              </button>
            </Row>
          </>
        </div>
      )}

      {/* Reports Tab Dropdown options in CMA */}
      {section === "filters" && selectedTab === 2 && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: "100%"
          }}
        >
          <Row
            gutter={[10, 10]}
            justify="start"
            style={{ width: "100%", marginTop: "12px" }}
          >
            <Col xs={24} sm={24} md={5} lg={5} xl={5}>
              <SingleSelectDropdown
                className="buy-con-dropdown-modal"
                label="From Date"
                childList={cmaReportFromDates}
                selectedValue={cmaReportFromDateSelected}
                setSelectedValue={onCmaReportFromDateChange}
              />
            </Col>
            <Col xs={24} sm={24} md={5} lg={5} xl={5}>
              <SingleSelectDropdown
                className="buy-con-dropdown-modal"
                label="To Date"
                childList={cmaReportToDates}
                selectedValue={cmaReportToDateSelected}
                setSelectedValue={onCmaReportToDateChange}
              />
            </Col>
          </Row>
        </div>
      )}

      {/* Reports Content in CMA */}
      {section === "content" && selectedTab === 2 && (
        <Row justify={"start"} style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card style={{ height: "100%", padding: "24px", width: "100%" }}>
              {isCMADataLoading ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: 300
                    }}
                  >
                    <LoadingSpinner
                      size={{ height: "80px", width: "80px" }}
                    />
                  </div>
                </>
              ) : renderedCmaSections.length > 0 ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                      width: "100%", minHeight: '625px'
                    }}
                  >
                    <div className="sba-cci-reports-section">
                      <div className="sba-cci-reports-section-report-title">
                        Repository
                      </div>
                      <div className="sba-cci-reports-accordion-wrap">
                        <AccordionV2
                          className=""
                          onClickAdd={function wRe() {}}
                          onUpdate={function wRe() {}}
                          presentation="box-shadow"
                          selectedItemIndex={cmaAccordionSelectedIndex}
                          style={{ position: "relative", width: "255px" }}
                        >
                          {renderedCmaSections.map(s =>
                            renderSection(cmaPdfReportData[s.key], s.label)
                          )}
                        </AccordionV2>
                      </div>
                    </div>

                    <div
                      className="sba-cci-pdf-section"
                      style={
                        pdfUrl == null
                          ? {
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center"
                            }
                          : {}
                      }
                    >
                      {pdfUrl == null ? (
                        <>
                          <div>
                            <EmptyStateV2
                              className=""
                              description="Select a report from the left panel to preview it here."
                              icon="insert_drive_file"
                              style={{
                                minHeight: "300px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                              titleContent="Pick a report to preview"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <iframe
                            src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`}
                            width="100%"
                            height="500px"
                            style={{
                              border: "none",
                              height: "100%"
                            }}
                            title="PDF Viewer"
                            loading="eager"
                            allow="cross-origin-isolated"
                          />
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <EmptyStateV2
                    className=""
                    description="No reports available for the selected date range"
                    icon="mobiledata_off"
                    style={{
                      minHeight: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  />
                </>
              )}
            </Card>
          </Col>
        </Row>
      )}

      {/* Pricing Content in CMA */}
      {section === "content" && selectedTab === 1 && (
        <>
        <Row  justify={"start"} style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div ref={linechartRef}>
            <Card style={{ height: "100%", padding: "24px", width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  position: "relative",
                  width: "100%"
                }}
              >
                {(isUserDataLoading || isFilterDataLoading || isLineDataLoading) ? (
                  <div className="sba-cci-linechart-section">
                  <SkeletonList count={10} height="30" />
                  </div>
                ) : (
                  <div  className="sba-cci-linechart-section">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                      width: "100%",
                      background: "#fff"
                    }}
                  >
                    <div
                      className="resin_linechart_header"
                      style={{
                        width: "100%",
                        alignItems: "center",
                        textAlign: "left",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "16px"
                      }}
                    >
                      <span className="cma-charts-title">
                        Price Trend
                      </span>
                      <span>
                        <DropdownWithIcons
                          modalRef={linechartRef}
                          kpiName={
                            "Price Trend"
                          }
                          checkPDFDownloaded={checkPDFDownloaded}
                        />
                      </span>
                    </div>
                    <div style={{ marginTop: "-10px" }}>
                      <span>
                        <span style={{fontWeight:"700"}}>Product:</span> {productSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Geography:</span> {geographySelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Grade:</span> {gradeSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Concept:</span> {conceptSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Terms:</span> {termsSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Unit of Measure:</span> {unitsSelected?.[0]?.displayText || "-"}
                      </span>
                    </div>
                    {renderForecastLegend()}
                    {
                        activePricingLineChartData?.series && activePricingLineChartData?.series?.length > 0 && (activePricingLineChartData?.actual?.length > 0 || activePricingLineChartData?.forecast?.length > 0) ?
                          <ResinLineChart
                            rawData={resinChartData}
                            lineChartactualData={resinLineChartActualData}
                            forecastStartLabel={resinForecastStartVal}
                            risiSeriesLineChartIndex={resinSeriesLineChartIndex}
                            firstForecastYearMonth={resinFirstForecastYearMonth}
                            firstForecastKeysToBeMergedActualLAst={resinFirstForecastKeysToBeMergedActualLast}
                            currencySymbol={currencySymbol}
                          />
                        :<NoData/>
                     }       
                  </div>
                </div>
                )}
              </div>
            </Card>
            </div>
          </Col>
        </Row>
        <Row justify={"start"} style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div ref={cmaTableRef}>
            <Card style={{ height: "100%", padding: "24px", width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  position: "relative",
                  width: "100%"
                }}
              >  
              {(isUserDataLoading || isFilterDataLoading || isTableDataLoading) ? (
                  <div className="sba-cci-barchart-section">
                  <SkeletonList count={10} height="30" />
                  </div>
                ) : (
                <div className="sba-cci-barchart-section">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                      width: "100%",
                      background: "#fff"
                    }}
                  >
                    <div
                      className="resin_barchart_header"
                      style={{
                        width: "100%",
                        alignItems: "center",
                        textAlign: "left",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "16px"
                      }}
                    >
                      <span className="cma-charts-title">
                        Product Price Details
                      </span>
                      <span>
                        <DropdownWithIcons
                          modalRef={cmaTableRef}
                          kpiName={"Product Price Details"}
                          checkPDFDownloaded={checkPDFDownloaded}
                          isTable={true}
                        />
                      </span>
                    </div>

                    <div style={{ marginTop: "-18px" }}>
                      <span>
                        <span style={{fontWeight:"700"}}>Product:</span> {productSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Geography:</span> {geographySelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Grade:</span> {gradeSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Concept:</span> {conceptSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Terms:</span> {termsSelected?.[0]?.displayText || "-"}
                      </span>
                    </div>
                    
                    {
                          activePricingTableData?.ProductPriceDetails && activePricingTableData?.ProductPriceDetails?.length > 0 ?
                            <CmaTable tableData={activePricingTableData?.ProductPriceDetails} cmaColumns={cmaColumns}/>
                          :<NoData/>
                    }
                  </div>
                </div>
                )}
               </div>
            </Card>
            </div>
          </Col>
        </Row>
        </>
      )}
    </>
  );
};

export default CmaSource;
